import { ClickEvent, Component, Layout, TableSelectionEvent } from "@mcleod/components";
import { AutogenLayoutPeriodicThreadDumps } from "./autogen/AutogenLayoutPeriodicThreadDumps";
import { Api, LogManager } from "@mcleod/core";
import { ThreadDumpParser, ThreadDumpType } from "./ThreadDumpParser";
import { CommonDialogs } from "@mcleod/common";

const log = LogManager.getLogger("general.PeriodicThreadDumps");

export class PeriodicThreadDumps extends AutogenLayoutPeriodicThreadDumps {
    tableThreadDumpsOnSelect(event: TableSelectionEvent) {
        const selectedRows = this.tableThreadDumps.selectedRows;
        if (selectedRows.length >= 1) {
            const selectedTimestamp = selectedRows[0].data.get("timestamp") as string;
            this.panelAnalysis.removeAll();

            Api.search("common/periodic-thread-dump", { timestamp: selectedTimestamp, include_content: true }).then(response => {
                const content = response.data[0].content;
                if (ThreadDumpParser.getThreadDumpType(content) != ThreadDumpType.INVALID) {
                    const dumpAnalyzer = Layout.getLayout("lme/general/ThreadDumpAnalyzer", { contents: content } as any);
                    this.panelAnalysis.add(dumpAnalyzer);
                }
            })
            .catch(error => {
                log.error("Failed to load thread dump:", error);
                CommonDialogs.showDialog("An error occurred loading the thread dump");
            });
        }
    }
}
